"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Badge = void 0;
var react_1 = __importDefault(require("react"));
var Corpo_1 = require("../Tipografia/Corpo/Corpo");
var Cores_1 = require("../Cores/Cores");
var Icone_1 = require("../Icone/Icone");
var badgeModule = require("./Badge.module.scss");
//#region Componente
var Badge = function (_a) {
    var id = _a.id, _b = _a.tipo, tipo = _b === void 0 ? "ponto" : _b, _c = _a.texto, texto = _c === void 0 ? "Badge" : _c, _d = _a.variante, variante = _d === void 0 ? "arredondado" : _d, _e = _a.icone, icone = _e === void 0 ? "favorite" : _e, _f = _a.estilo, estilo = _f === void 0 ? "info-azul500" : _f, style = _a.style, tamanho = _a.tamanho;
    var tipos = badgeModule[tipo] || "";
    var estados = badgeModule[estilo] || "";
    var variantes = badgeModule[variante] || "";
    var tamanhoBadge = badgeModule[tamanho !== null && tamanho !== void 0 ? tamanho : 'regular'] || "";
    var getCorEstado = function () {
        switch (estilo) {
            case "info-azul50":
                return Cores_1.Cores.CoresIdentidadeMU.azulMu;
            case "info-neutro50":
                return Cores_1.Cores.GradacaoNeutros.CinzaFillMU500;
            case "info-neutro100":
                return Cores_1.Cores.GradacaoNeutros.CinzaFillMU400;
            default:
                return Cores_1.Cores.CoresIdentidadeMU.brancoMu;
        }
    };
    var tipografiaCorpoPadrao = function (texto) { return react_1.default.createElement(react_1.default.Fragment, null, typeof texto === "string" ?
        react_1.default.createElement(Corpo_1.Corpo, { tipo: "overline", negrito: 400, cor: getCorEstado() }, texto)
        : texto); };
    var textoComIcone = function (texto, icone) { return (react_1.default.createElement("div", { className: badgeModule.textoComIcone },
        icone ? react_1.default.createElement(Icone_1.Icone, { nome: icone, cor: getCorEstado(), largura: "12px", altura: "12px" }) : undefined,
        typeof texto === "string" && texto ? tipografiaCorpoPadrao(texto) : texto)); };
    var badgeRender = function () {
        switch (tipo) {
            case "ponto":
                return react_1.default.createElement("span", { className: badgeModule.ponto });
            case "icone":
                return react_1.default.createElement(Icone_1.Icone, { nome: icone, cor: getCorEstado(), largura: "12px", altura: "12px" });
            case "texto":
                return tipografiaCorpoPadrao(texto);
            case "textoComIcone":
                return textoComIcone(texto, icone);
            default:
                return null;
        }
    };
    //#region Render
    return (react_1.default.createElement("div", { id: id, className: "".concat(badgeModule.container, " ").concat(tipos, " ").concat(estados, " ").concat(variantes, " ").concat(tamanhoBadge), style: style }, badgeRender()));
};
exports.Badge = Badge;
